import { FunctionComponent } from 'react';

import { TableDateCellProps } from './models/table-date-cell-props.model';

const TableDateCell: FunctionComponent<TableDateCellProps> = ({
  date,
}: TableDateCellProps) => {
  const cellDate = date ? new Date(date) : null;
  return <div>{cellDate?.toISOString().slice(0, 16).replace('T', ' ')}</div>;
};

export default TableDateCell;
